import {URL_BASE} from "../../utils/helper";

export function action (/* context */) {
}

export function getMedias (context, data ) {
    axios.get(URL_BASE + '/inspection_reports/'+ data.ir + '/gallery')
        .then((response) => {
            context.commit('setGallery', response.data.data)
        })
        .catch(error => {
            console.error(error)
            alert('Error get gallery')
        })
        .finally(() => null)
}
